module.exports = "/_next/static/images/ohio-48eac2e03c4eadc74e784fc849c544ca.svg";